import React from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ParagraphsRenderer,
  Breadcrumbs,
} from '../../../components';


import './style.scss';

const NodeBasicPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeBasicPage');
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Breadcrumbs />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="NodeBasicPage__hero__wrapper">
              <div className="NodeBasicPage__hero__wrapper__text">
                <h1 className="NodeBasicPage__hero__wrapper__title">{title}</h1>
                {body && (
                  <div className="NodeBasicPage__hero__wrapper__body">
                    <WysiwygField
                      property="schema:text"
                      className="text--large"
                      html={body}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <ParagraphsRenderer paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeBasicPage;
